import axios from 'axios'
import { ACCESS_TOKEN_NAME } from '../constants/Constants'

const headers = {
  'Content-Type': 'application/json',
  accept: 'application/json',
}

const http = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
})

const isUnauthenticatedError = (error) => {
  const statusCode = error?.response?.status
  const responseMessage = error?.response?.data?.message
  const nestedMessage = error?.response?.data?.data?.message
  const errorId = error?.response?.data?.data?.error_id

  return (
    statusCode === 401 ||
    errorId === 44 ||
    responseMessage === 'Unauthenticated.' ||
    nestedMessage === 'Unauthenticated.'
  )
}

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(ACCESS_TOKEN_NAME)
    const auth = token ? `Bearer ${token}` : ''

    config.headers = {
      ...config.headers,
      Accept: 'application/json',
      Authorization: `${auth}`,
    }

    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    } else {
      config.headers['Content-Type'] = 'application/json'
    }

    return config
  },
  (error) => Promise.reject(error),
)

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isUnauthenticatedError(error)) {
      localStorage.removeItem(ACCESS_TOKEN_NAME)
      if (window.location.pathname !== '/login') {
        window.location.replace('/login')
      }
    }

    return Promise.reject(error)
  },
)

const token = localStorage.getItem(ACCESS_TOKEN_NAME) || ''

const exportHttp = axios.create({
  baseURL: process.env.REACT_APP_EXPORT_URL,
  headers: { ...headers, Authorization: `Bearer ${token}` },
})

export const exportData = exportHttp

export default http
